/*
These functions make sure WordPress
and Foundation play nice together.
*/



jQuery(document).ready(function() {
	
	jQuery("#location-0").addClass("selected");
	
	 jQuery(".clickable>img").hover(function() {
		 jQuery(this).addClass( "bw" );
		 jQuery(this).parent(".clickable").find("div.person").find("img").addClass("pulse");
		 //jQuery(this).parent(".clickable").find("div.name").fadeOut("fast");
	  }, function() {
		 jQuery(this).removeClass( "bw" );
		 jQuery(this).parent(".clickable").find("div.person").find("img").removeClass("pulse");
		 //jQuery(this).parent(".clickable").find("div.name").fadeIn("fast");
	  }
    );
	
	jQuery(".pop-image img").click(function() {
		 jQuery(this).parent(".pop-image").next("div.cell").find(".map-img").css("display", "none");
		 jQuery(this).parent(".pop-image").next("div.cell").find("div.desc").css("display", "block");
		 jQuery(this).parent(".pop-image").find(".click-person").css("display", "none");
		 jQuery(".show-map").css("display", "block");
	 });

	 /*
	 jQuery(".show-map").click(function() {
		 jQuery(this).next("a").css("display", "block");
		 jQuery(this).prev("div.desc").css("display", "none");
		 jQuery(this).css("display", "none");
	 });
	 */
	 
	 jQuery(".close-button").click(function() {
		 jQuery(".pop-desc").find(".map-img").css("display", "block");
		 jQuery(".pop-image").find(".click-person").css("display", "block");
		 jQuery(".pop-desc").find("div.desc").css("display", "none");
		 jQuery(".show-map").css("display", "none");
		 
		 jQuery(".click-person").css("display", "block");
		 jQuery(".pop-desc").find("a").css("display", "block");
		 jQuery(".pop-desc").find(".desc").css("display", "none");
		 
		 jQuery("html, body").animate({ scrollTop: 0 }, "fast");
		 
	 });
	 
	 
	 jQuery(".close-window").click(function() {
		 jQuery(".restaurant-content").addClass("hideme");
	 });  
	 
	 jQuery(".about").click(function() {
		 jQuery(".menu-content").css("display","none");
		 jQuery(".about-content").css("display","block");
		 jQuery(this).addClass("active-menu");
		 jQuery(".insiders").removeClass("active-menu");
		 /*
		 if ( jQuery(this).hasClass("active") ) {
		 	jQuery(this).removeClass("active");
			jQuery(".about-content").css("display","none");
		 } else {
			jQuery(this).addClass("active");
			
		 }
		 */
	 });
	 
	 jQuery(".insiders").click(function() {
		 jQuery(".menu-content").css("display","none");
		 jQuery(".insiders-content").css("display","block");
		 jQuery(this).addClass("active-menu");
		 jQuery(".about").removeClass("active-menu");
	 });
	 
	 jQuery(".close-menu-content, .menuToggle.active").click(function() {
		 jQuery(".menu-content").css("display","none");
		 jQuery(".about").removeClass("active-menu");
		 jQuery(".insiders").removeClass("active-menu");
	 });
	 
	  jQuery(".menuToggle").click(function() {
		if ( jQuery(this).find('input').is(':checked') ) {
		 } else {
			//jQuery(this).addClass("active");
			jQuery(".menu-content").css("display","none");
			jQuery(".about").removeClass("active-menu");
		 	jQuery(".insiders").removeClass("active-menu");
		 }
	 });
	 
	 jQuery(".insider-click > a").click(function() {
		 jQuery(".click-person").css("display", "none");
		 jQuery(".pop-desc").find(".map-image-link").css("display", "none");
		 jQuery(".pop-desc").find(".desc").css("display", "block");
		 jQuery(".pop-desc").find(".show-map").css("display", "block");
	 });

	jQuery(document).ready(function(){ 
		jQuery('.image-gallery').slick({
		  dots: false,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 2,
		  slidesToScroll: 1,
		  responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true,
				dots: true
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		  ]
		});
	});
	 
	 
	var directionsService = new google.maps.DirectionsService;
	var directionsDisplay = new google.maps.DirectionsRenderer(
							  {
								  suppressMarkers: true,
								  suppressBicyclingLayer: true
							  });
	var bounds = new google.maps.LatLngBounds();
	var map = new google.maps.Map(document.getElementById('map'), {
	  mapTypeId: google.maps.MapTypeId.ROADMAP,
	  styles: [
            {
              featureType: 'transit',
              elementType: 'geometry',
              stylers: [{visibility: 'off'}]
            }    
          ]
	});
	
	directionsDisplay.setMap(map);
	
	/*
	directionsDisplay.setOptions({
	  polylineOptions: {
		strokeColor: 'blue'
	  }
	});
	*/
	
	var infowindow = new google.maps.InfoWindow();
	
	var marker, i;
	
	var icon = {
		url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png", // url
		scaledSize: new google.maps.Size(40, 40), // scaled size
		origin: new google.maps.Point(0,0), // origin
		anchor: new google.maps.Point(0, 0) // anchor
	};
	
	for (i = 0; i < locations.length; i++) {  
	  marker = new google.maps.Marker({
		position: new google.maps.LatLng(locations[i][1], locations[i][2]),
		map: map,
		icon: icon
	  });
	  
	  bounds.extend(marker.position);
		
	  if ( i == 0 ) {
		  infowindow.setContent(locations[0][0]);
		  infowindow.open(map,marker);
	  }
	  
	  google.maps.event.addListener(marker, 'click', (function(marker, i) {
		return function() {
		  infowindow.setContent(locations[i][0]);
		  infowindow.open(map, marker);

		  jQuery(".restaurant-content").removeClass("hideme");
		  jQuery(".location").removeClass("selected");
		  jQuery("#location-" + i).addClass("selected");
		  
			
		};
	  })(marker, i));
	}
	
	if ( jQuery(window).width() >= 769) {      
		map.fitBounds(bounds, { left: 650, top: 170 });
	} else if ( jQuery(window).width() >= 641) {      
		map.fitBounds(bounds, { left: 550, top: 0 });
	}  else if ( jQuery(window).width() <= 640) { 
		map.fitBounds(bounds);
	}
	
	
	var onChangeHandler = function() {
	  calculateAndDisplayRoute(directionsService, directionsDisplay);
	};
	document.getElementById('start').addEventListener('change', onChangeHandler);
	document.getElementById('end').addEventListener('change', onChangeHandler);
	
	function calculateAndDisplayRoute(directionsService, directionsDisplay) {
		directionsService.route({
		  origin: document.getElementById('start').value,
		  destination: document.getElementById('end').value,
		  travelMode: 'WALKING'
		}, function(response, status) {
		  if (status === 'OK') {
			directionsDisplay.setDirections(response);
		  } else {
			window.alert('Directions request failed due to ' + status);
		  }
		});
	  } 

			
}); 



